<template>
  <div>
    <div class="cart_agree_conts">
      <div class="cart_agree">
        <span class="agree_txt">
          <input
            class="check-all-compulsory"
            id="allPaymentTermsAgree"
            name="allPaymentTermsAgree"
            type="checkbox"
            :checked="isAgreeAll"
            @change="toggleAll"
          />
          <label for="allPaymentTermsAgree" class="focus"
            >[필수] 전체 동의하기</label
          >
        </span>
      </div>
    </div>
    <div class="cart_agree_conts">
      <div class="cart_agree" v-if="purchaseType === 'single'">
        <span class="agree_txt">
          <input
            class="check-single"
            id="paymentTermsAgree"
            name="paymentTermsAgree"
            type="checkbox"
            v-model="paymentTermsAgree"
            @change="changeCheckbox"
          />
          <label for="paymentTermsAgree" class="focus"
            >주문하실 상품의 상품명, 가격, 배송정보를 확인하였으며, 이에
            동의(전자상거래법 제8조 제2항)</label
          >
        </span>
      </div>
      <div class="cart_agree" v-if="purchaseType === 'recurring'">
        <span class="agree_txt">
          <input
            class="check-all"
            id="paymentTermsAgree"
            name="paymentTermsAgree"
            type="checkbox"
            :checked="
              paymentTermsAgree1 &&
              paymentTermsAgree2 &&
              paymentTermsAgree3 &&
              paymentTermsAgree4
            "
            @change="changeAllCheckboxWithoutToss"
          />
          <label for="paymentTermsAgree" class="focus"
            >이용 약관에 모두 동의합니다.</label
          >
        </span>
        <a
          href="#down20"
          data-toggle="collapse"
          class="collapsed btn_view_agree"
          aria-expanded="false"
        >
          <span class="pull-right icon-arr"><span>약관보기</span></span>
        </a>
        <div id="down20" class="panel-collapse applicants-panel collapse">
          <div class="applicants-panel-in">
            <div class="cart_agree0">
              <input
                class="login-form-remember"
                id="paymentTermsAgree1"
                name="paymentTermsAgree1"
                type="checkbox"
                v-model="paymentTermsAgree1"
                @change="changeCheckbox"
              />
              <label for="paymentTermsAgree1" class="focus"
                >본인은 본 정기구매로 신청한 제품은 매월 정기 결제해야 하며,
                별도의 해지 신청을 하지 않을 시에는 본인이 신청한 결제수단으로
                매월 정기 결제 되는 것에 동의합니다. 자동결제 해지는 결제일 3일
                이전에 신청하셔야 하며, 결제일이 도래하기 1일~2일 사이에 (예를
                들어, 결제일이 25일인 경우, 23일~24일) 해지신청을 하시면, 당월은
                결제가 이루어지고 익월에 해지신청이 반영됩니다.</label
              >
            </div>
            <div class="cart_agree0">
              <input
                class="login-form-remember"
                id="paymentTermsAgree2"
                name="paymentTermsAgree2"
                type="checkbox"
                v-model="paymentTermsAgree2"
                @change="changeCheckbox"
              />
              <label for="paymentTermsAgree2" class="focus"
                >주문하실 상품의 상품명, 가격, 배송정보를 확인하였으며, 이에
                동의(전자상거래법 제8조 제2항)</label
              >
            </div>
            <div class="cart_agree0">
              <input
                class="login-form-remember"
                id="paymentTermsAgree3"
                name="paymentTermsAgree3"
                type="checkbox"
                v-model="paymentTermsAgree3"
                @change="changeCheckbox"
              />
              <label for="paymentTermsAgree3" class="focus"
                >정기구매와 관련된 혜택 및 내용 등 구체적인 운영기준은 회사의
                정책에 따라 추가되거나 변경될 수 있습니다. 상기 사항 및 불리한
                조건 변경일 경우 회사가 인터넷 홈페이지, 이메일 등을 통해
                개별적으로 공지합니다.</label
              >
            </div>
            <div class="cart_agree0">
              <input
                class="login-form-remember"
                id="paymentTermsAgree4"
                name="paymentTermsAgree4"
                type="checkbox"
                v-model="paymentTermsAgree4"
                @change="changeCheckbox"
              />
              <label for="paymentTermsAgree4" class="focus"
                >개인정보 수집 및 이용에 동의</label
              >
              <a class="title" @click="onTerms">자세히 보기 </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cart_agree_conts toss" v-show="isTossTermsRequired">
      <div class="cart_agree">
        <div class="toss_agree_box">
          <div class="toss_agree_box_inner">
            <span class="agree_txt">
              <input
                class="login-form-remember-toss"
                type="checkbox"
                id="paymentTermsAgreeToss1"
                name="paymentTermsAgreeToss1"
                v-model="paymentTermsAgreeToss1"
                @change="changeCheckbox"
              />
              <label for="paymentTermsAgreeToss1" class="focus"
                >TOSS 개인정보 수집 이용 동의</label
              >
            </span>
            <a class="title" @click="openPopUp(2)"> 자세히 보기 </a>
          </div>
          <div class="toss_agree_box_inner">
            <span class="agree_txt">
              <input
                class="login-form-remember-toss"
                type="checkbox"
                id="paymentTermsAgreeToss2"
                name="paymentTermsAgreeToss2"
                v-model="paymentTermsAgreeToss2"
                @change="changeCheckbox"
              />
              <label for="paymentTermsAgreeToss2" class="focus"
                >TOSS 전자금융거래 기본 약관</label
              >
            </span>
            <a class="title" @click="openPopUp(3)"> 자세히 보기 </a>
          </div>
          <div class="toss_agree_box_inner">
            <span class="agree_txt">
              <input
                class="login-form-remember-toss"
                type="checkbox"
                id="paymentTermsAgreeToss3"
                name="paymentTermsAgreeToss3"
                v-model="paymentTermsAgreeToss3"
                @change="changeCheckbox"
              />
              <label for="paymentTermsAgreeToss3" class="focus"
                >TOSS 개인정보 제3자 제공 동의</label
              >
            </span>
            <a class="title" @click="openPopUp(4)"> 자세히 보기 </a>
          </div>
        </div>
      </div>
    </div>
    <modal-privacy-consent ref="refModal" />
  </div>
</template>

<script>
import ModalPrivacyConsent from "@/components/modal-popups/ModalPrivacyConsent.vue";
export default {
  name: "PaymentTerms",
  components: {
    ModalPrivacyConsent,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    purchaseType: {
      type: String,
      required: true,
    },
    isTossTermsRequired: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paymentTermsAgree: this.value,
      paymentTermsAgree1: this.value,
      paymentTermsAgree2: this.value,
      paymentTermsAgree3: this.value,
      paymentTermsAgree4: this.value,
      paymentTermsAgreeToss1: this.value,
      paymentTermsAgreeToss2: this.value,
      paymentTermsAgreeToss3: this.value,
    };
  },
  computed: {
    isAgreeAll() {
      if (this.purchaseType === "single") {
        if (this.isTossTermsRequired) {
          return (
            this.paymentTermsAgree &&
            this.paymentTermsAgreeToss1 &&
            this.paymentTermsAgreeToss2 &&
            this.paymentTermsAgreeToss3
          );
        } else {
          return this.paymentTermsAgree;
        }
      } else if (this.purchaseType === "recurring") {
        if (this.isTossTermsRequired) {
          return (
            this.paymentTermsAgree1 &&
            this.paymentTermsAgree2 &&
            this.paymentTermsAgree3 &&
            this.paymentTermsAgree4 &&
            this.paymentTermsAgreeToss1 &&
            this.paymentTermsAgreeToss2 &&
            this.paymentTermsAgreeToss3
          );
        } else {
          return (
            this.paymentTermsAgree1 &&
            this.paymentTermsAgree2 &&
            this.paymentTermsAgree3 &&
            this.paymentTermsAgree4
          );
        }
      }
    },
  },
  methods: {
    onTerms(event) {
      event.preventDefault();
      this.$refs.refModal.open();
    },
    toggleAll(event) {
      const checked = event.target.checked;
      if (this.purchaseType === "single") {
        this.paymentTermsAgree = checked;
        this.paymentTermsAgreeToss1 = checked;
        this.paymentTermsAgreeToss2 = checked;
        this.paymentTermsAgreeToss3 = checked;
      } else if (this.purchaseType === "recurring") {
        this.paymentTermsAgree = checked;
        this.paymentTermsAgree1 = checked;
        this.paymentTermsAgree2 = checked;
        this.paymentTermsAgree3 = checked;
        this.paymentTermsAgree4 = checked;
        this.paymentTermsAgreeToss1 = checked;
        this.paymentTermsAgreeToss2 = checked;
        this.paymentTermsAgreeToss3 = checked;
      }
      this.$emit("input", this.isAgreeAll);
    },
    changeAllCheckboxWithoutToss(event) {
      const checked = event.target.checked;
      this.paymentTermsAgree1 = checked;
      this.paymentTermsAgree2 = checked;
      this.paymentTermsAgree3 = checked;
      this.paymentTermsAgree4 = checked;
      
      this.$emit("input", this.isAgreeAll);
    },
    changeCheckbox(event) {
      this.$emit("input", this.isAgreeAll);
    },
    openPopUp(termsId = 0) {
      this.$emit("open-popup", { index: termsId, display: true });
    },
  },
};
</script>

<style>
</style>